import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {HTH} from "../HTH";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class HTHSound {

    //action spins sounds
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static REELS_SPIN_IN: string = "reelsSpinIn";
    public static REELS_SPIN_OUT: string = "reelsSpinOut";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"];

    //loop sounds
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static FS_MUSIC: string = "freespin";
    public static BONUS_OUTRO: string = "bonusOutro";
    public static BONUS_OUTRO_GOOD: string = "bonusOutroGood";
    public static BONUS_INTRO: string = "bonusIntro";
    public static SFS_MUSIC: string = "superFreespin";

    //effects
    //win sounds
    public static INDIVIDUAL_WIN: string = "individualWin";
    public static INDIVIDUAL_WIN_EXPLODE: string[] = ["individualWinExplode1", "individualWinExplode2", "individualWinExplode3"];
    public static explodeSoundPlaying: string = "";
    public static INDIVIDUAL_WIN_REEL_EXPLODE: string[] = ["individualWinExplodeReel1", "individualWinExplodeReel2", "individualWinExplodeReel3", "individualWinExplodeReel4", "individualWinExplodeReel5", "individualWinExplodeReel6"];
    public static COUNTUP: string = "countup";
    public static COUNTUP_END_LARGE: string = "countupEndLarge";
    public static COUNTUP_END_MEDIUM: string = "countupEndMedium";
    public static COUNTUP_END_SMALL: string = "countupEndSmall";
    public static COUNTUP_END_TINY: string = "countupEndTiny";
    public static COUNTUP_FS_END_GOOD: string = "fsOutroCountupEndsGood";
    public static COUNTUP_FS_END_BAD: string = "fsOutroCountupEndsBad";
    public static ROUND_END_FINAL_WIN: string = "gameRoundFinalWin";

    //bigwin sounds
    public static BIGWIN: string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static BIGWIN_INTRO: string = "bigwinIntro";
    public static BIGWIN_END: string = "bigwinEnd";

    //miscellaneous
    public static BONUS_OUTRO_ENDS: string = "bonusOutroEnd";
    public static FS_END_BAD: string = "fsEndBad";
    public static FS_END_GOOD: string = "fsEndGood";
    public static FS_INTRO_START: string = "fsIntroStart";
    public static CONTINUE_BUTTON: string = "continueButton";
    public static AVASPLIT: string = "randomSplit";
    public static XWAYS_POTENTIAL_WINHIGHLIGHT: string = "potentialWinHighlight";
    public static ENHANCER_CELL_DOOR_CLOSE: string = "cellDoorClose";
    public static ENHANCER_CELL_DOOR_LOCK_OFF: string = "cellDoorLockOff";
    public static ENHANCER_CELL_DOOR_LOCK_ON: string = "cellDoorLockOn";
    public static ENHANCER_CELL_DOOR_OPEN: string = "cellDoorOpen";
    public static SCATTER_METER_ADD_LIGHT: string = "scatterMeterAddLight";
    public static PLUS_TWO_SPINS_UI: string = "plusSpinsSplash";

    //feature sounds
    //xways
    public static XWAYS_LANDING: string = "xWaysLanding";
    public static XWAYS_REVEAL: string = "xWaysExpand";
    //rw (demon)
    public static REMOVAL_LANDING: string = "RWLanding";
    public static REMOVAL_COLLECT: string = "RWCollect";
    public static REMOVAL_COLLECT_SWEEP: string = "RWCollectSweep";
    public static REMOVAL_TARGET_SYMBOLS: string = "RWRemoveSymbols";
    public static REMOVAL_REVEAL: string = "RWReveal";
    //xsplit
    public static XSPLIT_LANDING: string = "xSplitLanding";
    public static XSPLIT_XSPLIT: string = "xSplitSplit";
    public static XSPLIT_TO_WILD: string = "xSplitToWild";
    public static WILD_LANDING: string = "wildLanding";
    //xnudge
    public static XN_LANDING: string = "xNudgeLanding";
    public static XN_NUDGE: string = "xNudgeNudge";
    public static XN_BIKER: string = "xNudgeBike";
    public static XN_ABORT: string = "xNudgeNudgeAbort";
    public static XN_NOWIN: string = "xNudgeNudgeNoWin";
    //scatter
    public static SCATTER_1: string = "scatter1";
    public static SCATTER_2: string = "scatter2";
    public static SCATTER_3: string = "scatter3";
    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_ENDS: string = "scatterAnticipationEnds";
    public static SCATTER_FS: string = "scatterFS";
    public static SCATTER_SUPER_ADD_ON: string = "scatterSuperAddon";
    public static SCATTER_WIN: string = "scatterWin";


    //safe
    public static SCATTER_TO_GOLD: string = "scatterToGold";
    public static SAFE_OPEN: string = "goldCellDoorOpen";
    public static SAFE_CLOSE: string = "goldCellDoorClose";

    public static MAX_WIN_SYMBOL_REVEAL = "capwinReveal";
    public static CAPWIN_COUNTUP = "capwinCountup";
    public static CAPWIN_COUNTUP_END = "capwinCountupEnds";
    public static CAPWIN_LOOP = "capwinMusic";
    public static CAPWIN_END = "capwinMusicEnds";

    public static BG_TRANSITION: string = "bgTransition";

    public static soundSwitchedDuringFS: boolean = false;

    private static _currentMusic: string;
    private static davidPanningReelStop: number[] = [-0.15, -0.10, -0.05, 0.05, 0.10, 0.15];
    private _player: NolimitAudioPlayer;

    constructor() {
        this._player = <NolimitAudioPlayer>HTH.sound;
        this._player.showLogs(true);
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>HTH.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === HTHSound._currentMusic) {
            return;
        }

        if (HTHSound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = HTHSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000,
                        onComplete: () => {
                            HTHSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    HTHSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                HTHSound.soundPlayer.stopTrack(HTHSound._currentMusic);
            }
        }

        HTHSound.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            HTHSound.soundPlayer.fadeTrack(fadeInConf);
        }
        HTHSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        HTHSound.soundPlayer.fadeTrack({
            name: HTHSound._currentMusic,
            to: vol,
            duration: duration
        });
    }

    public static playTrack(soundName: string, vol?: number, repeat?: number): NolimitHowl | undefined {
        return HTHSound.soundPlayer.playTrack({name: soundName, volume: vol, repeat: repeat});
    }

    public static fadeOutAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade = HTHSound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    HTHSound.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            HTHSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    public static fadeInAndStartSound(fadeOutConf: IFadeTrackConf): void {
        const fade = HTHSound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    HTHSound.soundPlayer.playTrack({name: fadeOutConf.name, volume: fadeOutConf.to});
                }
            });
        } else {
            HTHSound.soundPlayer.playTrack({name: fadeOutConf.name});
        }
    }

    public static stopSound(name: string): void {
        HTHSound.soundPlayer.stopTrack(name);
    }

    public static playLandingSound(reelId: number): void {
        const sound: NolimitHowl | undefined = this.soundPlayer.playTrack({
            name: this.REELS_LANDING[reelId],
            repeat: 0
        });
        if (sound) {
            sound.player.stereo(HTHSound.davidPanningReelStop[reelId]);
        }
    }

    public static resetSoundStuff(): void {
        this.REELS_LANDING = ArrayHelper.shuffle(this.REELS_LANDING);
    }

    public static playSFSMusic(safeSymPos: { x: number, y: number }[]): void {
        const totalNumofSafes: number = safeSymPos.length;
        if (totalNumofSafes >= 3) {
            HTHSound.switchMusic({name: HTHSound.SFS_MUSIC});
        } else {
            HTHSound.switchMusic({name: HTHSound.FS_MUSIC});
        }
    }

    public static playRandomWinExplode(speed: number): void {
        HTHSound.explodeSoundPlaying = ArrayHelper.getRandomValue(HTHSound.INDIVIDUAL_WIN_EXPLODE);
        HTHSound.playTrack(HTHSound.explodeSoundPlaying)?.setRate(speed);
    }
}